export default {
    ENV: process.env.VUE_APP_ENVILOMENT,
    API_BASE_URL: process.env.VUE_APP_API_BASE_URL,

    AUTH_HEADER: 'X-AUTH-TOKEN',
    FAQS_URL: process.env.VUE_APP_FAQS_URL,
    FORGOT_PASSWORD_URL: process.env.VUE_APP_FORGOT_PASSWORD_URL,
    DOWNLOAD_URL: process.env.VUE_APP_DOWNLOAD_URL,
    E_SERVICE_URL: process.env.VUE_APP_E_SERVICE_URL,
    HOMEPAGE_URL: process.env.VUE_APP_HOMEPAGE_URL,
    PATENTSCOPE_URL: process.env.VUE_APP_PATENTSCOPE_URL,

    AUTH_STORAGE_KEY: process.env.VUE_APP_ENVILOMENT !== 'prod' ? process.env.VUE_APP_ENVILOMENT + '-' + 'auth-token' : 'auth-token',
    AUTH_SAVE_EMAIL_KEY: process.env.VUE_APP_ENVILOMENT !== 'prod' ? process.env.VUE_APP_ENVILOMENT + '-' + 'auth-email' : 'auth-email',
  };